import {Translate} from 'react-redux-i18n';
import Modal from 'react-modal';
import PropTypes from 'prop-types';

function ModalWaitingSignature(props) {
  return (
    <Modal
      defaultStyles={{
        overlay: {
          backgroundColor: 'rgba(255,255,255,0.7)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0
        },
        content: {
          backgroundColor: '#fff',
          borderRadius: 4,
          boxShadow: 'rgba(0, 0, 0, 0.35) 0px 0px 32px 0px',
          outline: 0,
          padding: 20,
          position: 'relative',
          maxWidth: 800,
          textAlign: 'center'
        }
      }}
      isOpen={props.isOpen}
    >
      <Translate value="document.signWaitingText"/>
    </Modal>
  );
}

ModalWaitingSignature.propTypes = {
  isOpen: PropTypes.bool.isRequired
};

export default ModalWaitingSignature;
